import { render, staticRenderFns } from "./PaymentPaysera.vue?vue&type=template&id=5ce522a0&"
import script from "./PaymentPaysera.vue?vue&type=script&lang=js&"
export * from "./PaymentPaysera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports